import React, { useState } from 'react';
import 'src/style/login.css';
import { Row, Col, Form, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GoBrowser, GoGraph, GoLocation } from 'react-icons/go';
import Logo from 'src/Images/E-Track-logo.png';
import { login } from 'src/redux/Actions/Auth';
import { useMediaQuery } from '@mui/system';
import { Alert } from '@mui/material';

Login.js;

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [showMissingCredentials, setShowMissingCredentials] = useState(null);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showSubscriptionError, setShowSubscriptionError] = useState(false);

  const isMobile = useMediaQuery('(max-width:600px)');
  const handleSubmitLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData(e.currentTarget);
    const userdata = {
      username: data.get('username'),
      password: data.get('password'),
    };

    if (userdata.username !== '' && userdata.password !== '') {
      dispatch(login(userdata))
        .then((response) => {
          setLoading(false);
          if (response && response.super_admin) {
            navigate('/dashboard/');
          } else if (response && response.organisation_admin) {
            navigate('/dashboard/');
          } else if (response && response.normal_user) {
            navigate('/dashboard/');
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.message === 'credentials') {
            setShowPasswordError(true);
          } else if (error.message === 'subscription') {
            setShowSubscriptionError(true);
          }
        });
    } else {
      if (userdata.username === '' && userdata.password === '') {
        setShowMissingCredentials(1);
      } else if (userdata.username === '') {
        setShowMissingCredentials(2);
      } else if (userdata.password === '') {
        setShowMissingCredentials(3);
      }
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <Row className="login-container">
        {!isMobile && (
          <Col className="login-left-section" xxl={7} xl={7} lg={7}>
            <div className="left-content">
              <div className="heading-title div-flex-column">
                <span>Helping Enhance and</span>
                <span> Optimise factory operations</span>
              </div>
              <div className="heading-body">
                <GoBrowser className="bullet-icon" />
                <span>Real time monitoring</span>
              </div>
              <div className="heading-body">
                <GoLocation className="bullet-icon" />
                <span>Accurate & Scalable Tracking</span>
              </div>
              <div className="heading-body">
                <GoGraph className="bullet-icon" />
                <span>Enhances Analytics & Efficiency</span>
              </div>
            </div>
          </Col>
        )}

        <Col className="login-right-section" xxl={5} xl={5} lg={5}>
          <div className="right-content div-flex-column rg-20">
            <img
              src={Logo}
              alt="logo"
              className="logo"
              style={{ width: '80px', height: '50px' }}
            />
            <div className="div-flex-column rg-5">
              <div className="heading-main">
                <span>Login to your account</span>
              </div>
              <div className="heading-body">
                <span>It&apos;s nice to see you again. Ready to track?</span>
              </div>
            </div>
            <Form onSubmit={handleSubmitLogin}>
              <Form.Group>
                <input
                  type="text"
                  name="username"
                  className="login-form-input"
                  placeholder="Your username or email"
                />
              </Form.Group>
              <Form.Group>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="login-form-input"
                  placeholder="Your password"
                />
                <span
                  role="button"
                  className="text-sm"
                  tabIndex={0}
                  onClick={togglePasswordVisibility}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      togglePasswordVisibility();
                    }
                  }}
                >
                  {showPassword ? 'Hide Password' : 'Show Password'}
                </span>
              </Form.Group>
              <button
                type="submit"
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? <span className="loader"></span> : 'Log In'}
              </button>
            </Form>
          </div>
        </Col>
      </Row>
      <Modal
        show={Boolean(showMissingCredentials)}
        onHide={() => setShowMissingCredentials(null)}
      >
        <Alert severity="warning">
          {showMissingCredentials === 1
            ? 'Please enter both your username/email and password to continue.'
            : showMissingCredentials === 2
              ? 'Please enter your username/email to continue.'
              : 'Please enter your password to continue.'}
        </Alert>
      </Modal>
      <Modal
        show={showPasswordError}
        onHide={() => setShowPasswordError(false)}
      >
        <Alert severity="error">
          Oops! Something went wrong. Please verify your login details
        </Alert>
      </Modal>
      <Modal
        show={showSubscriptionError}
        onHide={() => setShowSubscriptionError(false)}
      >
        <Alert severity="error">
          Vehicle Tracking subscription is not enabled for this tenant.
        </Alert>
      </Modal>
    </>
  );
}
